import { storiesOf } from '@storybook/vue';
import { withKnobs } from '@storybook/addon-knobs';
import { EventBus } from '@/main/eventBus';
import { PageMode } from '@/main/utils/pageMode';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const stories = storiesOf('Components/DMS/Form', module);

stories
	.addDecorator(withKnobs)
	.add('Checkbox Group', () => ({
		template: `
			<dms-form>
				<dms-check-group :value.sync="value" :items="list"  />
			</dms-form>
		`,
		store: new Vuex.Store({
			getters: {
				GET_TEXT_FROM: () => (localizationType, key) => ({ key }),
				GET_TEXT: () => (key) => ({ key }),
			},
		}),
		data() {
			return {
				value: [],
				list: [
					{
						Disabled: false,
						Text: 'Náhon 4x4',
						Value: 1000002,
						Label: null,
					},
					{
						Disabled: true,
						Text: 'Osobní',
						Value: 1000001,
						Label: null,
					},
					{
						Disabled: false,
						Text: 'Užitková',
						Value: 1000000,
						Label: null,
					},
				],
			};
		},
		mounted() {
			EventBus.$emit('Mode', PageMode.EDIT);
		},
	}));
